import { exclamationMarkTriangle32 } from "@esri/calcite-ui-icons";

import { useTranslation } from "react-i18next";

interface MessageProps {
  message: string;
}

interface AlertProps {
  message: MessageProps;
}

export default function Alert({ message }: AlertProps) {
  const { t } = useTranslation("common");

  return (
    <div className="bg-yellow-50 bg-opacity-90 p-4 px-6 md:px-auto">
      <div className="max-w-screen-xl mx-auto container flex flex-wrap items-center md:flex-nowrap mx-auto">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-yellow-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
          >
            <path d={exclamationMarkTriangle32} />
          </svg>
        </div>
        <div className="ml-3">
          <div className="text-yellow-700">
            <p>
              <>
                {t("alerts.unexpected", {
                  detail: message.message.replace(/\.$/, ""),
                })}
              </>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
